import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-proctoring-delete-config',
	standalone: true,
	imports: [MatDialogModule, CommonModule],
	templateUrl: './proctoring-delete-config.component.html',
	styleUrl: './proctoring-delete-config.component.scss'
})
export class ProctoringDeleteConfigComponent implements OnInit {

	rulesetName = ''


	constructor(
		private dialogRef: MatDialogRef<ProctoringDeleteConfigComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { name: string, type: 'ruleset' | 'assessment' | 'rule' | 'configuration'; }
	) { }


	ngOnInit(): void {
		this.rulesetName = this.data.name;
	}



	close() {
		this.dialogRef.close(false);
	}


	delete() {
		this.dialogRef.close(true);
	}

	get title(): string {
		switch (this.data.type) {
			case 'assessment':
				return 'Assessment';
			case 'ruleset':
				return 'Ruleset';
			case 'rule':
				return 'Rule';
			case 'configuration':
				return 'Configuration';
			default:
				return 'Delete';
		}
	}
}
